const enUS = {
  PersonalInfo: {
    pageTitle: `Starting Point - Home`,
    accessibilityFieldset: 'A form asking about you.',
    schemaErrorMessage:
      'Oh no! We ran into a technical problem loading the quiz. Please refresh your page.',
    schemaShapeErrorMessage:
      'Oh no! We ran into a technical problem loading the quiz. Please try again later.',
    modalHeader: 'Why do we ask about you?',
    modalParagraph:
      "There's a reason these questions matter, and it's not so we can collect data. Some solutions are only relevant (or only available) to people in select age groups or in certain employment situations.",
    modalButtonText: 'Okay, got it!',
    header: 'Tell us about yourself',
    HomeText: {
      heading: 'Find your Starting Point',
      headingTwo: 'Answer a few questions, get information relevant to you.',
      paragraphOnePart1: 'At ',
      linkText: 'Edward Jones',
      linkUrl: 'https://edwardjones.com/us-en',
      paragraphOnePart2:
        ", we start by understanding what's important to you. But understanding how to get started managing your finances can be overwhelming. That's why we created this tool.",
      paragraphTwo:
        'Regardless of whether you become an Edward Jones client, we hope this tool helps you get started on a path to meeting your financial goals.',
    },
    Disclaimer: {
      paragraph:
        'Starting Point is meant to provide you with information that may be relevant to you. It is intended for educational purposes only, and the results will be based upon the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. Starting Point does not provide all possible information that may be relevant in your unique situation.',
    },
    PersonalInfoForm: {
      ageLabel: 'How old are you?',
      ageAriaLabel: 'age-input',
      radioLegend: 'What is your employment status?',
      ageInstructions: 'You must enter an age between 18 and 120.',
      ageErrorSentence: 'You must enter an age between %MIN_AGE%',
      ageErrorConjunction: ' and %MAX_AGE%.',
      retiredAgeGreaterThanAge:
        'If you are retired, your current age should at least be your retirement age',
      retiredAgeLesserThanAge:
        'If you are not retired, your current age should be no more than your retirement age',
      retiredPrompt: 'What age were you when you retired?',
      willRetirePrompt: 'At what age would you like to retire?',
      moreInfoAboutRetirementAgeAriaLabel:
        'Click here for more information about retirement age.',
      retAgeTooltip:
        'Social Security considers full retirement age to be 66 or 67 depending on what year you were born (when you qualify for 100% of your benefits).',
      employmentStatusRetired: 'Retired',
      retAgeModalButtonText: 'Okay, got it!',
    },
  },
  HouseholdInfo: {
    pageTitle: `Starting Point - Household`,
    accessibilityFieldset: 'A form asking about your household.',
    maritalLegend: 'What is your marital status?',
    dependentLegend: 'Do you have any dependents?',
    modalHeader: 'Why do we ask about your household?',
    modalParagraph:
      'Your family is an important part of your financial picture and may point to anticipated goals or needs.',
    modalButton: 'Okay, got it!',
    header: 'Tell us about your household',
  },
  HopesInfo: {
    pageTitle: `Starting Point - Aspirations & Concerns`,
    accessibilityFieldset: 'A form asking about your goals and worries.',
    modalHeader: 'Why do we ask about your financial aspirations and concerns?',
    modalParagraph:
      'The things you aspire to help set your financial goals, while the things you are concerned about create potential challenges. We want to suggest relevant solutions that take both of these into account.',
    modalButton: 'Okay, got it!',
    heading: 'Tell us about your financial aspirations & concerns',
    hopesLabel: 'Which of these are you most hopeful for? ',
    worriesLabel: 'Which of these are you most concerned about? ',
    checkAllNote: '(Check all that apply)',
    getResults: 'Get results',
    MultiSelect: {
      closeButton: 'Close',
      itemPrompt: 'Choose as many as apply to you',
    },
    employmentStatusRetired: 'Retired',
  },
  Results: {
    pageTitle: `Starting Point - Results`,
    ResultsItem: {
      reasonEnding: ', you might explore...',
    },
    Recommendation: {
      firstPrompt: 'What is this? ',
      secondPrompt: 'How does it affect me? ',
      thirdPrompt: 'A Financial Advisor can:',
      resources: 'Explore more:',
    },
    ResultsGreeting: {
      heading: 'Your results',
      greetingParagraphPart1:
        "Below, you'll find some ideas that you may want to explore based on the answers you've provided. If you're inspired to take the next step and talk with a ",
      linkText: 'financial advisor',
      linkUrl:
        'https://www.edwardjones.com/us-en/search/financial-advisor/results?distance=50&page=1&query=&view=list',
      greetingParagraphPart2:
        ', you can get a holistic perspective about how you might realize your goals.',
      greetingParagraphAlternate:
        'Based on your answers, here are some topics you might want to check out.',
    },
    ResultsMoreInfo: {
      header: "Whoops! We'll need more information",
      paragraph:
        'Thanks for trying out Starting Point! In order to provide you with a starting point, we need a little more information. Please answer a few more questions to receive relevant content here.',
    },
    SendResultsButton: {
      sendButton: 'Send results to financial advisor',
      successButton: 'Your results have been sent',
      successNotification:
        'Thank you for sending your results – they have been shared with the financial advisor.',
      coldContactSuccessMessage: `Thank you for sending your results – %FA_NAME% will review them and be in touch.`,
      defaultText: 'your financial advisor',
      errorMsg:
        'Oh no! We ran into a problem trying to send your results. Please download your results and contact your financial advisor.',
      coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
    },
    SaveResultsButton: {
      saveButton: 'Save your results',
      successButton: 'Your results have been sent',
      successNotification:
        'Thank you for sending your results – you should receive them shortly.',
      errorMsg:
        'Oh no! We ran into a problem trying to send your results. Please try again.',
    },
    ConnectFA: {
      header: 'Connect with a financial advisor',
      connectBtnLabel:
        'Tell us about yourself to match with financial advisors ready to work with you',
      connectLinkText: 'Find matches',
      connectLinkURL: 'https://match.edwardjones.com/',
      separatorText: 'OR',
      searchLabel: 'Search by location (city, state or ZIP)',
      searchInitialValue: 'Enter Location',
      searchSubmitButton: 'Search results',
      url: 'https://www.edwardjones.com/us-en/search/financial-advisor/results?query=',
    },
    EJMatchGateway: {
      header: 'Ready to talk with a financial advisor?',
      matchBtnLabel:
        'Enter your zip code to take a quick quiz that can match you with someone focused on your goals and preferences.',
      matchLabel: 'Your ZIP code:',
      searchInitialValue: 'Is this needed?',
      matchSubmitButton: 'Get matched',
      url: 'https://match.edwardjones.com/location?postalCode=',
    },
    NewContactModalForm: {
      header: `Share your results with %FA_NAME%`,
      paragraphText: `By providing your name and email, you can share your Starting Point quiz results and the underlying answers you provided with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
      legalText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
      firstNameLabel: 'First name*',
      lastNameLabel: 'Last name*',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      requiredLabel: '*Email or Phone is required',
      cancelButton: 'Cancel',
      shareButton: 'Share my results',
      firstNameError:
        'Please provide a valid first name.  It can contain the following characters: ',
      lastNameError:
        'Please provide a valid last name.  It can contain the following characters: ',
      validNameChars: "‘’´' -",
      emailError: 'Please provide a valid email or phone',
      missingEmailError: 'Please provide a valid email',
      customPhoneMask: '(999) 999-9999',
      customPhoneMaskHelperText: '(999) 999-9999',
      phoneError: 'Please provide a valid phone or email',
      defaultText: 'your financial advisor',
      consentError: 'Please provide consent',
      consentLabel:
        'I give Edward Jones permission to contact me by email and/or phone*',
      emailMeLabel:
        'Email a copy of results to the email address provided above',
    },
    WebProspectModalForm: {
      header: `Send results to your email`,
      paragraphText: `Enter your contact information to send your Starting Point results to refer to as needed.`,
      firstNameLabel: 'First name*',
      lastNameLabel: 'Last name*',
      emailLabel: 'Email*',
      cancelButton: 'Cancel',
      shareButton: 'Save results',
      firstNameError:
        'Please provide a valid first name.  It can contain the following characters: ',
      lastNameError:
        'Please provide a valid last name.  It can contain the following characters: ',
      emailError: 'Please provide a valid email',
      validNameChars: "‘’´' -",
      consentError: 'Please provide consent',
      consentLabel:
        "By agreeing to have results sent to my email, I agree to Edward Jones Privacy Policy. I elect to receive further communications from Edward Jones. If I've previously unsubscribed, I'm acknowledging that I'm resubscribing with Edward Jones.*",
    },
    CommentModal: {
      header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
      paragraphOneText: `By selecting "Share my results", you will share your Starting Point quiz results and the underlying answers you provided with your financial advisor. They will be in touch to discuss how your priorities can shape your financial strategy.`,
      paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
      label: `Comment (optional)`,
      subTextOne: `Max Length: %MAX_LENGTH%`,
      subTextTwo: `Characters Left: %CHARS_LEFT%`,
      commentError: `Comments cannot contain`,
      invalidChars: '`~*^[]{}',
      defaultText: `your financial advisor`,
      cancelButton: 'Cancel',
      shareButton: 'Share my results',
    },
    resultsDisclaimer: `The results from Starting Point are for educational purposes only, are based upon the selections you have made, and may vary depending upon how you answered the questions. The results may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice and additional factors should be considered when determining your goals and financial strategy. Starting Point does not provide all possible information that may be relevant in your unique situation.`,
    resultsError:
      'Oh no! We ran into a technical problem trying to return your results. Please start over.',
    downloadError: 'Something went wrong, please try again.',
    timestampError:
      "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
    topResultsHeading: 'Your top results',
    moreResultsHeading: 'More results relevant to you',
    downloadPdfButton: 'Download your results',
    startOverButton: 'Start over',
    findFaButton: 'Find a financial advisor',
    findFaLink: 'https://www.edwardjones.com/find-financial-advisor.html',
    myPrioritiesLinkBox: {
      header: `What are your priorities?`,
      paragraph: `Need help determining what your financial priorities are? The "My Priorities" quiz can help. It's an important step in building a comprehensive financial strategy.`,
      buttonText: `Take the My Priorities quiz`,
      id: `linkbox-btn-mp`,
      link: `${window.location.origin}?callerAppName=StartingPoint`, // Logic to switch startingpoint to mypriorities within app
      imgSrc: `/public/images/my-priorities.png`,
      ariaLabel: `Computer and mobile phone displaying My Priorities Quiz`,
    },
    gettingStartedLinkBox: {
      header: `How we can work for you`,
      paragraph: `We've created a page with all the basic information you need to know about how we work at Edward Jones, and how the right financial advisor can help create an investment strategy that's built for you.`,
      buttonText: `Get started`,
      id: `linkbox-btn-gs`,
      link: `https://www.edwardjones.com/us-en/get-started`,
      imgSrc: ``,
      ariaLabel: `Woman at laptop computer`,
    },
    retireCalcLinkBox: {
      header: `Retirement savings calculator`,
      paragraph: `70% of pre-retirees don't think they saved enough for retirement. How about you? Do you think you're on track? Use our calculator.`,
      buttonText: `Try the retirement savings calculator`,
      id: `linkbox-btn-rc`,
      link: `https://www.edwardjones.com/preparing-for-your-future/calculators-checklists/calculators/retirement-savings-calculator.html`,
      imgSrc: `/public/images/calculator.png`,
      ariaLabel: `Calculator`,
    },
    eJMatchLinkBox: {
      header: `Find the best financial advisors for you`,
      paragraph: `Edward Jones match only takes 5 minutes and matches you on 40 match dimensions to find your best fit.`,
      buttonText: `Match with a financial advisor`,
      link: `https://match.edwardjones.com/`,
      imgSrc: `/public/images/client-and-advisor.png`,
      ariaLabel: `Client and financial advisor discussing document`,
    },
    shareQuizCta: {
      shareQuizHeading: 'Share the Starting Point quiz link',
      shareQuizMessage:
        'Share the Starting Point quiz with friends or family and compare your results.',
      copyLinkButton: 'Copy link',
      linkCopiedSuccessfully: 'Link copied',
      copiedUrl: `${window.location.origin}`,
      shareLink: 'Share link:',
      defaultEmailText: `mailto:?subject=I think you'd like the Starting Point quiz&body=Check out this tool to help you get started on a path to meeting your financial goals: ${window.location.origin}`,
      linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
      faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
      socialMediaTitle: 'Share to %APP_NAME%',
    },
  },
  Error: {
    errorTextLine1: `We're sorry, but something went wrong.`,
    errorTextLine2: `We are working to fix it, please try again later.`,
    firstPageLinkText: `Return to the quiz`,
  },
  AllPages: {
    App: {
      personalPath: '/',
      householdPath: '/household',
      goalsPath: '/hopes',
      resultsPath: '/results',
      errorPath: '/error',
    },
    StepIndicator: {
      steps: ['Personal', 'Household', 'Goals', 'Results'],
      stepUrls: ['/', '/household', '/hopes', '/results'],
    },
    TopBar: {
      heading: 'Starting Point',
      link: 'https://www.edwardjones.com',
    },
    BottomBar: {
      careersLink: `https://careers.edwardjones.com/`,
      careersText: `Careers`,
      personalFinanceLink: `https://www.edwardjones.com/hidden-assets/active-blog-articles.html`,
      personalFinanceText: `Personal Finance`,
      feedbackLink: `https://www.edwardjones.com/feedback-form.html`,
      feedbackText: `Feedback`,
      privacyLink: `https://www.edwardjones.com/privacy/index.html`,
      privacyText: `Privacy`,
      revenueSharingLink: `https://www.edwardjones.com/sites/default/files/acquiadam/2021-02/revenue-sharing-disclosure.pdf`,
      revenueSharingText: `Revenue Sharing (pdf)`,
      formCrsLink: `https://www.edwardjones.com/us-en/disclosures/best-interest-relationship-summary`,
      formCrsText: `Form CRS`,
      disclosuresLink: `https://www.edwardjones.com/disclosures/index.html`,
      disclosuresText: `Disclosures`,
      accessibilityLink: `https://www.edwardjones.com/us-en/accessibility-policy`,
      accessibilityText: `Accessibility Policy`,
      copyrightParagraph: `Copyright © %CURRENT_YEAR% Edward Jones. All rights reserved. Member `,
      sipcLink: `https://www.sipc.org/`,
      sipcText: `SIPC`,
      disclaimerParagraph: `This site is designed for U.S. residents only. The services offered within this site are available exclusively through our U.S. financial advisors. Edward Jones' U.S. financial advisors may only conduct business with residents of the states for which they are properly registered. Please note that not all of the investments and services mentioned are available in every state.`,
    },
    backButton: 'Back',
    nextButton: 'Next',
  },
};

const enCA = {
  PersonalInfo: {
    pageTitle: `Starting Point - Home`,
    accessibilityFieldset: 'A form asking about you.',
    schemaErrorMessage:
      'Oh no! We ran into a technical problem loading the quiz. Please refresh your page.',
    schemaShapeErrorMessage:
      'Oh no! We ran into a technical problem loading the quiz. Please try again later.',
    modalHeader: 'Why do we ask about you?',
    modalParagraph:
      "There's a reason these questions matter, and it's not so we can collect data. Some solutions are only relevant (or only available) to people in select age groups or in certain employment situations.",
    modalButtonText: 'Okay, got it!',
    header: 'Tell us about yourself',
    HomeText: {
      heading: 'Find your Starting Point',
      headingTwo: 'Answer a few questions, get information relevant to you.',
      paragraphOnePart1: 'At ',
      linkText: 'Edward Jones',
      linkUrl: 'https://edwardjones.ca/ca-en',
      paragraphOnePart2:
        ", we start by understanding what's important to you. But understanding how to get started managing your finances can be overwhelming. That's why we created this tool.",
      paragraphTwo:
        'Regardless of whether you become an Edward Jones client, we hope this tool helps you get started on a path to meeting your financial goals.',
    },
    Disclaimer: {
      paragraph:
        'Starting Point is meant to provide you with information that may be relevant to you. It is intended for educational purposes only, and the results will be based upon the selections you make. The results are not intended to offer any financial advice or constitute any recommendations. Starting Point does not provide all possible information that may be relevant in your unique situation.',
    },
    PersonalInfoForm: {
      ageLabel: 'How old are you?',
      ageAriaLabel: 'age-input',
      radioLegend: 'What is your employment status?',
      ageInstructions: 'You must enter an age between 18 and 120.',
      ageErrorSentence: 'You must enter an age between %MIN_AGE%',
      ageErrorConjunction: ' and %MAX_AGE%.',
      retiredAgeGreaterThanAge:
        'If you are retired, your current age should at least be your retirement age',
      retiredAgeLesserThanAge:
        'If you are not retired, your current age should be no more than your retirement age',
      retiredPrompt: 'What age were you when you retired?',
      willRetirePrompt: 'At what age would you like to retire?',
      moreInfoAboutRetirementAgeAriaLabel:
        'Click here for more information about retirement age.',
      retAgeTooltip:
        'For CPP/QPP and OAS purposes, age 65 is the age you could qualify for unreduced benefits.',
      employmentStatusRetired: 'Retired',
      retAgeModalButtonText: 'Okay, got it!',
    },
  },
  HouseholdInfo: {
    pageTitle: `Starting Point - Household`,
    accessibilityFieldset: 'A form asking about your household.',
    maritalLegend: 'What is your marital status?',
    dependentLegend: 'Do you have any dependents?',
    modalHeader: 'Why do we ask about your household?',
    modalParagraph:
      'Your family is an important part of your financial picture and may point to anticipated goals or needs.',
    modalButton: 'Okay, got it!',
    header: 'Tell us about your household',
  },
  HopesInfo: {
    pageTitle: `Starting Point - Aspirations & Concerns`,
    accessibilityFieldset: 'A form asking about your goals and worries.',
    modalHeader: 'Why do we ask about your financial aspirations and concerns?',
    modalParagraph:
      'The things you aspire to help set your financial goals, while the things you are concerned about create potential challenges. We want to suggest relevant solutions that take both of these into account.',
    modalButton: 'Okay, got it!',
    heading: 'Tell us about your financial aspirations & concerns',
    hopesLabel: 'Which of these are you most hopeful for? ',
    worriesLabel: 'Which of these are you most concerned about? ',
    checkAllNote: '(Check all that apply)',
    getResults: 'Get results',
    MultiSelect: {
      closeButton: 'Close',
      itemPrompt: 'Choose as many as apply to you',
    },
    employmentStatusRetired: 'Retired',
  },
  Results: {
    pageTitle: `Starting Point - Results`,
    ResultsItem: {
      reasonEnding: ', you might explore...',
    },
    Recommendation: {
      firstPrompt: 'What is this? ',
      secondPrompt: 'How does it affect me? ',
      thirdPrompt: 'A Financial Advisor can:',
      resources: 'Explore more:',
    },
    ResultsGreeting: {
      heading: 'Your results',
      greetingParagraphPart1:
        "Below, you'll find some ideas that you may want to explore based on the answers you've provided. If you're inspired to take the next step and talk with a ",
      linkText: 'financial advisor',
      linkUrl:
        'https://www.edwardjones.ca/ca-en/search/financial-advisor/results?distance=50&page=1&query=&view=list',
      greetingParagraphPart2:
        ', you can get a holistic perspective about how you might realize your goals.',
    },
    ResultsMoreInfo: {
      header: "Whoops! We'll need more information",
      paragraph:
        'Thanks for trying out Starting Point! In order to provide you with a starting point, we need a little more information. Please answer a few more questions to receive relevant content here.',
    },
    SendResultsButton: {
      sendButton: 'Send results to financial advisor',
      successButton: 'Your results have been sent',
      successNotification:
        'Thank you for sending your results – they have been shared with the financial advisor.',
      coldContactSuccessMessage: `Thank you for sending your results – %FA_NAME% will review them and be in touch.`,
      defaultText: 'your financial advisor',
      errorMsg:
        'Oh no! We ran into a problem trying to send your results. Please download your results and contact your financial advisor.',
      coldContactErrorMessage: `Oh no! We ran into a problem trying to send your results.  Please download your results and contact %FA_FIRSTNAME%.`,
    },
    SaveResultsButton: {
      saveButton: 'Save your results',
      successButton: 'Your results have been sent',
      successNotification:
        'Thank you for sending your results – you should receive them shortly.',
      errorMsg:
        'Oh no! We ran into a problem trying to send your results, please try again.',
    },
    ConnectFA: {
      header: 'Find a financial advisor',
      connectBtnLabel:
        'Tell us about yourself to match with financial advisors ready to work with you',
      connectLinkText: 'Find matches',
      connectLinkURL: 'https://match.edwardjones.com/', // .ca is not working yet
      separatorText: 'OR',
      searchLabel: 'Search by location (City, Province or Postal Code)',
      searchInitialValue: 'Enter Location',
      searchSubmitButton: 'Search results',
      url: 'https://www.edwardjones.ca/ca-en/search/financial-advisor/results?query=',
    },
    NewContactModalForm: {
      header: `Share your results with %FA_NAME%`,
      paragraphText: `By providing your name and email, you can share your Starting Point quiz results and the underlying answers you provided with %FA_NAME%. They will be in touch to discuss how your priorities can shape your financial strategy.`,
      legalText: `If the advisor you've selected is unavailable, you may hear back from a different Edward Jones financial advisor.`,
      firstNameLabel: 'First name*',
      lastNameLabel: 'Last name*',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      requiredLabel: '*Email or Phone is required',
      cancelButton: 'Cancel',
      shareButton: 'Share my results',
      firstNameError:
        'Please provide a valid first name.  It can contain the following characters: ',
      lastNameError:
        'Please provide a valid last name.  It can contain the following characters: ',
      emailError: 'Please provide a valid email or phone',
      missingEmailError: 'Please provide a valid email',
      customPhoneMask: '(999) 999-9999',
      customPhoneMaskHelperText: '(999) 999-9999',
      phoneError: 'Please provide a valid phone or email',
      validNameChars: "‘’´' -",
      defaultText: 'your financial advisor',
      consentError: 'Please provide consent',
      consentLabel:
        'I give Edward Jones permission to contact me by email and/or phone*',
      emailMeLabel:
        'Email a copy of results to the email address provided above',
    },
    CommentModal: {
      header: `%CONTACT_FIRSTNAME%, you are sharing your results with %FA_NAME%.`,
      paragraphOneText: `By selecting "Share my results", you will share your Starting Point quiz results and the underlying answers you provided with your financial advisor. They will be in touch to discuss how your priorities can shape your financial strategy.`,
      paragraphTwoText: `Anything else you'd like them to know about these results? Leave a comment below.`,
      label: `Comment (optional)`,
      subTextOne: `Max Length: %MAX_LENGTH%`,
      subTextTwo: `Characters Left: %CHARS_LEFT%`,
      commentError: `Comments cannot contain`,
      invalidChars: '`~*^[]{}',
      defaultText: `your financial advisor`,
      cancelButton: 'Cancel',
      shareButton: 'Share my results',
    },
    resultsDisclaimer: `The results from Starting Point are for educational purposes only, are based upon the selections you have made, and may vary depending upon how you answered the questions. The results may not account for your unique circumstances and do not constitute a recommendation of any investment or strategy type. This information is not intended to offer any financial advice and additional factors should be considered when determining your goals and financial strategy. Starting Point does not provide all possible information that may be relevant in your unique situation.`,
    resultsError:
      'Oh no! We ran into a technical problem trying to return your results. Please start over.',
    downloadError: 'Something went wrong, please try again.',
    timestampError:
      "Sorry we can't automatically send out your results at this time. Please download your results and discuss with your local Financial Advisor, or request a new link.",
    topResultsHeading: 'Your top results',
    moreResultsHeading: 'More results relevant to you',
    startOverButton: 'Start over',
    downloadPdfButton: 'Download your results',
    findFaButton: 'Find a financial advisor',
    findFaLink:
      'https://www.edwardjones.ca/find-financial-advisor.html?source=sp',
    myPrioritiesLinkBox: {
      header: `What are your priorities?`,
      paragraph: `Need help determining what your financial priorities are? The "My Priorities" quiz can help. It's an important step in building a comprehensive financial strategy.`,
      buttonText: `Take the My Priorities quiz`,
      link: `${window.location.origin}?callerAppName=StartingPoint`, // Logic to switch startingpoint to mypriorities within app
      imgSrc: `/public/images/my-priorities.png`,
      ariaLabel: `Computer and mobile phone displaying My Priorities Quiz`,
    },
    retireCalcLinkBox: {
      header: `Retirement savings calculator`,
      paragraph: `70% of pre-retirees don't think they saved enough for retirement. How about you? Do you think you're on track? Use our calculator.`,
      buttonText: `Try the retirement savings calculator`,
      link: `https://www.edwardjones.ca/preparing-for-your-future/calculators-checklists/calculators/retirement-savings-calculator.html`,
      imgSrc: `/public/images/calculator.png`,
      ariaLabel: `Calculator`,
    },
    eJMatchLinkBox: {
      header: `Find the best financial advisors for you`,
      paragraph: `Edward Jones match only takes 5 minutes and matches you on 40 match dimensions to find your best fit.`,
      buttonText: `Match with a financial advisor`,
      link: `https://match.edwardjones.com/`,
      imgSrc: `/public/images/client-and-advisor.png`,
      ariaLabel: `Client and financial advisor discussing document`,
    },
    shareQuizCta: {
      shareQuizHeading: 'Share the Starting Point quiz link',
      shareQuizMessage:
        'Share the Starting Point quiz with friends or family and compare your results.',
      copyLinkButton: 'Copy link',
      linkCopiedSuccessfully: 'Link copied',
      copiedUrl: 'https://startingpoint.edwardjones.ca/',
      shareLink: 'Share link:',
      defaultEmailText: `mailto:?subject=I think you'd like the Starting Point quiz&body=Check out this tool to help you get started on a path to meeting your financial goals: ${window.location.origin}`,
      linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
      faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
      socialMediaTitle: 'Share to %APP_NAME%',
    },
  },
  Error: {
    errorTextLine1: `We're sorry, but something went wrong.`,
    errorTextLine2: `We are working to fix it, please try again later.`,
    firstPageLinkText: `Return to the quiz`,
  },
  AllPages: {
    App: {
      personalPath: '/',
      householdPath: '/household',
      goalsPath: '/hopes',
      resultsPath: '/results',
      errorPath: '/error',
    },
    LanguageSelect: {
      languageSelectLabel: 'Country: ',
      languageSelectTexts: 'Canada | English,Canada | Français',
      languageSelectTextDefault: 'Canada | English',
      languageDialogCancel: 'Cancel/Annuler',
      languageDialogLeave: 'Leave/Sortir',
      languageDialogTitle1: 'You will lose your quiz progress.',
      languageDialogTitle2: 'Vous perdrez votre progression.',
      languageDialogQuestion1: 'Do you want to leave your quiz?',
      languageDialogQuestion2: 'Que souhaitez-vous sortir du questionnaire?',
    },
    StepIndicator: {
      steps: ['Personal', 'Household', 'Goals', 'Results'],
      stepUrls: ['/', '/household', '/hopes', '/results'],
    },
    TopBar: {
      heading: 'Starting Point',
      link: 'https://www.edwardjones.ca',
    },
    BottomBar: {
      careersLink: `https://careers.edwardjones.ca/`,
      careersText: `Careers`,
      feedbackLink: `https://www.edwardjones.ca/feedback-form.html`,
      feedbackText: `Feedback`,
      privacyLink: `https://www.edwardjones.ca/disclosures/account-protection-privacy/privacy-notice.html`,
      privacyText: `Privacy`,
      disclosuresLink: `https://www.edwardjones.ca/disclosures/index.html`,
      disclosuresText: `Disclosures`,
      accessibilityLink: `https://www.edwardjones.ca/ca-en/accessibility-policy`,
      accessibilityText: `Accessibility Policy`,
      member: `Member - `,
      CIPFLink: `https://www.cipf.ca/`,
      CIPFText: `Canadian Investor Protection Fund`,
      member2: `. Member - `,
      IIROCLink: `https://www.ciro.ca/`,
      IIROCText: `Canadian Investment Regulatory Organization`,
      line1: `Welcome to the Edward Jones Website. This site is published in Canada exclusively for residents of Canadian jurisdictions where our products and services may be legally offered. The services offered within this site are available exclusively through our Canadian advisors. Edward Jones' Canadian advisors may only conduct business with residents of the province(s) in which they are registered.`,
      line2: `Copyright © %CURRENT_YEAR% Edward D. Jones & Co., L.P. Single copies of our Internet pages may be downloaded or printed solely for personal use. It is otherwise prohibited to modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products or services obtained from this site. Edward Jones® is a registered trademark of Edward D. Jones & Co., L.P.`,
      line3: `Edward Jones is a limited partnership in Canada and is a wholly owned subsidiary of Edward D. Jones & Co., LP, a Missouri limited partnership. Edward D. Jones & Co., LP is a wholly owned subsidiary of The Jones Financial Companies, LLLP, a limited liability limited partnership.`,
      line4: `Edward Jones and its independent affiliate in the United States, collectively, serve more than 7 million investors.`,
      line5: `*In Quebec, our advisors are known as Investment Advisors.`,
    },
    backButton: 'Back',
    nextButton: 'Next',
  },
};

const frCA = {
  PersonalInfo: {
    pageTitle: `Point de départ - Accueil`,
    accessibilityFieldset:
      'Un formulaire de demande de renseignements à votre sujet.',
    schemaErrorMessage:
      'Oh, non! Nous avons rencontré un problème technique lors du chargement du questionnaire. Veuillez rafraîchir votre page.',
    schemaShapeErrorMessage:
      'Oh, non! Nous avons rencontré un problème technique lors du chargement du questionnaire. Veuillez réessayer plus tard.',
    modalHeader: 'Pourquoi posons-nous des questions à votre sujet?',
    modalParagraph:
      'Il y a une raison pour laquelle ces questions sont importantes, et ce n’est pas pour que nous puissions collecter des données. Certaines solutions ne sont pertinentes (ou uniquement disponibles) que pour les personnes appartenant à certains groupes d’âge ou dans certaines situations professionnelles.',
    modalButtonText: 'Allons-y!',
    header: 'Parlez nous de vous',
    HomeText: {
      heading: 'Trouvez votre Point de départ',
      headingTwo:
        'Répondez à quelques questions et obtenez des informations pertinentes pour vous.',
      paragraphOnePart1: 'Chez ',
      linkText: 'Edward Jones',
      linkUrl: 'https://edwardjones.ca/ca-fr',
      paragraphOnePart2:
        ', nous commençons par comprendre ce qui est important pour vous. Mais apprendre comment débuter à gérer ses finances peut s’avérer très difficile. C’est pourquoi nous avons créé cet outil.',
      paragraphTwo:
        'Peu importe que vous deveniez ou non un client d’Edward Jones, nous espérons que cet outil vous aidera à commencer à atteindre vos objectifs financiers.',
    },
    Disclaimer: {
      paragraph:
        'Le questionnaire Point de départ a pour but de vous fournir des renseignements qui pourraient vous intéresser. Il est destiné à des fins éducatives uniquement, et les résultats seront fondés sur vos choix. Les résultats ne sont pas destinés à fournir des conseils financiers ni à donner une quelconque recommandation. Le questionnaire Point de départ ne fournit pas tous les renseignements qui pourraient être pertinents dans votre situation particulière.',
    },
    PersonalInfoForm: {
      ageLabel: 'Quel âge avez-vous?',
      ageAriaLabel: "entrée-d'âge ",
      radioLegend: 'Quelle est votre situation professionnelle?',
      ageInstructions: 'Vous devez saisir un âge compris entre 18 et 120 ans.',
      ageErrorSentence: 'Vous devez saisir un âge compris entre %MIN_AGE%',
      ageErrorConjunction: ' et %MAX_AGE% ans.',
      retiredAgeGreaterThanAge:
        'Si vous êtes à la retraite, votre âge devrait correspondre au moins à l’âge où vous avez pris votre retraite.',
      retiredAgeLesserThanAge:
        'Si vous n’êtes pas à la retraite, votre âge ne devrait pas dépasser l’âge où vous avez pris votre retraite.',
      retiredPrompt: 'À quel âge avez-vous pris votre retraite?',
      willRetirePrompt: 'À quel âge aimeriez-vous prendre votre retraite?',
      moreInfoAboutRetirementAgeAriaLabel:
        "Cliquez ici pour plus d'informations sur l'âge minimal de la retraite",
      retAgeTooltip:
        'Pour le RPC/RRQ et la SV, 65 ans est l’âge auquel vous pourriez obtenir 100% de vos prestations.',
      employmentStatusRetired: 'Retraité',
      retAgeModalButtonText: 'Allons-y!',
    },
  },
  HouseholdInfo: {
    pageTitle: `Point de départ - Ménage`,
    accessibilityFieldset: 'Un formulaire pour connaître votre ménage.',
    maritalLegend: 'Quel est votre état matrimonial?',
    dependentLegend: 'Avez-vous des personnes à charge?',
    modalHeader: 'Pourquoi posons-nous des questions sur votre ménage?',
    modalParagraph:
      'Votre famille est une partie importante en lien à votre situation financière et peut indiquer des objectifs ou des besoins anticipés.',
    modalButton: 'Allons-y!',
    header: 'Parlez-nous de votre ménage',
  },
  HopesInfo: {
    pageTitle: `Point de départ - Espoirs et inquiétudes`,
    accessibilityFieldset:
      'Un formulaire pour connaître vos objectifs et vos préoccupations.',
    modalHeader:
      'Pourquoi posons-nous des questions sur vos aspirations et vos préoccupations financières?',
    modalParagraph:
      'Vos aspirations vous aident à fixer vos objectifs financiers, tandis que vos préoccupations créent des défis potentiels. Nous voulons proposer des solutions pertinentes qui tiennent compte de ces deux composantes.',
    modalButton: 'Allons-y!',
    heading:
      'Parlez-nous de vos aspirations et vos préoccupations financières?',
    hopesLabel: 'Lequel de ces éléments vous procure le plus d’espoir? ',
    worriesLabel: 'Lequel de ces éléments vous préoccupe le plus? ',
    checkAllNote: '(Cochez toutes les cases qui s’appliquent)',
    getResults: 'Obtenir les résultats',
    MultiSelect: {
      closeButton: 'Fermer',
      itemPrompt: 'Choisissez toutes les réponses qui s’appliquent à vous',
    },
    employmentStatusRetired: 'Retraité',
  },
  Results: {
    pageTitle: `Point de départ - Résultats`,
    ResultsItem: {
      reasonEnding: ', vous pourriez explorer…',
    },
    Recommendation: {
      firstPrompt: `Qu'est-ce que c'est? `,
      secondPrompt: `Comment cela m'affecte-t-il? `,
      thirdPrompt: 'Un conseiller en investissement peut\xa0:',
      resources: 'Explore more:',
    },
    ResultsGreeting: {
      heading: 'Vos résultats',
      greetingParagraphPart1:
        'Vous trouverez ci-dessous quelques idées que vous voudrez peut-être explorer en fonction des réponses que vous avez fournies. Si vous avez envie de passer à l’étape suivante et de parler avec ',
      linkText: 'un conseiller en investissement',
      linkUrl:
        'https://www.edwardjones.ca/ca-fr/recherche/conseiller-en-investissement/resultats?query=',
      greetingParagraphPart2:
        ', vous pouvez obtenir une perspective globale sur la manière de réaliser vos objectifs.',
    },
    ResultsMoreInfo: {
      header: 'Oups! Nous aurons besoin de plus d’informations.',
      paragraph:
        'Merci d’avoir essayé notre questionnaire «\xa0\xa0Point de départ\xa0\xa0»! Pour vous donner un point de départ, nous avons besoin d’un peu plus d’informations. Veuillez répondre à quelques questions supplémentaires pour recevoir du contenu pertinent ici.',
    },
    SendResultsButton: {
      sendButton: 'Envoyez vos résultats au conseiller en investissement',
      successButton: 'Vos résultats ont été envoyés.',
      successNotification:
        'Merci d’avoir envoyé vos résultats – ils ont été communiqués au conseiller en investissement.',
      coldContactSuccessMessage: `Merci d’avoir envoyé vos résultats – %FA_NAME% en prendra connaissance et communiquera avec vous.`,
      defaultText: 'votre conseiller en investissement',
      errorMsg:
        'Oh, non! Nous avons rencontré un problème lors de l’envoi de vos résultats. Veuillez télécharger vos résultats et communiquer avec votre conseiller en investissement.',
      coldContactErrorMessage: `Oh, non! Nous avons rencontré un problème lors de l’envoi de vos résultats. Veuillez télécharger vos résultats et communiquer avec %FA_FIRSTNAME%.`,
    },
    SaveResultsButton: {
      saveButton: 'Sauvegarder vos résultats',
      successButton: 'Vos résultats ont été envoyés.',
      successNotification:
        'Merci d’avoir envoyé vos résultats – vous devriez les recevoir sous peu.',
      errorMsg:
        'Oh, non! Nous avons rencontré un problème lors de l’envoi de vos résultats. Veuillez réessayer.',
    },
    ConnectFA: {
      header: 'Trouver un conseiller en investissement',
      connectBtnLabel:
        'Tell us about yourself to match with financial advisors ready to work with you',
      connectLinkText: 'Find matches',
      connectLinkURL: 'https://match.edwardjones.com/', // .ca is not working yet
      separatorText: 'OU',
      searchLabel: 'Recherche par emplacement (Ville, Province ou code postal)',
      searchInitialValue: 'Entrez votre emplacement',
      searchSubmitButton: 'Recherche',
      url: 'https://www.edwardjones.ca/ca-fr/recherche/conseiller-en-investissement/resultats?query=',
    },
    NewContactModalForm: {
      header: `Partagez votre résultats avec %FA_NAME%`,
      paragraphText: `En indiquant votre nom et votre adresse courriel, vous pouvez partager vos résultats du questionnaire Point de départ et les réponses sous - jacentes que vous avez fournies avec %FA_NAME%. Ce conseiller communiquera avec vous pour discuter de la façon dont vos priorités peuvent orienter votre stratégie financière.`,
      legalText: `Si le conseiller que vous avez choisi n’est pas disponible, il est possible qu’un autre conseiller en investissement Edward Jones communique avec vous.`,
      firstNameLabel: 'Prénom*',
      lastNameLabel: 'Nom de famille*',
      emailLabel: 'Adresse courriel',
      phoneLabel: 'Numéro de téléphone',
      requiredLabel:
        '*Un adresse courriel ou un numéro de téléphone est requis',
      cancelButton: 'Annuler',
      shareButton: 'Partager mes résultats',
      firstNameError:
        'Veuillez fournir un prénom valide. Il peut contenir les caractères suivants\xa0: ',
      lastNameError:
        'Veuillez fournir un nom de famille valide.Il peut contenir les caractères suivants\xa0: ',
      emailError:
        'Veuillez fournir une adresse courriel ou un numéro de téléphone valide',
      missingEmailError: 'Veuillez fournir une adresse courriel valide',
      customPhoneMask: '(999) 999-9999',
      customPhoneMaskHelperText: '(999) 999-9999',
      phoneError:
        'Veuillez fournir une adresse courriel ou un numéro de téléphone valide',
      validNameChars: "‘’´' -",
      defaultText: 'votre conseiller en investissement',
      consentError: 'Veuillez donner votre consentement',
      consentLabel:
        'J’autorise Edward Jones à communiquer avec moi par courriel ou par téléphone*',
      emailMeLabel:
        'Envoyez une copie des résultats par courriel à l’adresse indiquée ci-dessus',
    },
    CommentModal: {
      header: `%CONTACT_FIRSTNAME%, vous partagez vos résultats avec %FA_NAME%.`,
      paragraphOneText: `En sélectionnant «\xa0\xa0Partager mes résultats\xa0\xa0», vous partagerez vos résultats du questionnaire Point de départ et les réponses sous-jacentes que vous avez fournies avec votre conseiller en investissement. Ce conseiller communiquera avec vous pour discuter de la façon dont vos priorités peuvent orienter votre stratégie financière.`,
      paragraphTwoText: `Y a-t-il autre chose que vous aimeriez qu’il sache à propos de ces résultats? Laissez un commentaire ci-dessous.`,
      label: `Commentaire (facultatif)`,
      subTextOne: `Longueur maximum\xa0: %MAX_LENGTH%`,
      subTextTwo: `Caractères restants\xa0: %CHARS_LEFT%`,
      commentError: `Les commentaires ne peuvent pas contenir`,
      invalidChars: '`~*^[]{}',
      defaultText: `votre conseiller en investissement`,
      cancelButton: 'Annuler',
      shareButton: 'Partager mes résultats',
    },
    resultsDisclaimer: `Les résultats du questionnaire Point de départ sont fournis à titre d’information seulement. Ils sont fondés sur vos propres choix et peuvent varier en fonction de la façon dont vous avez répondu aux questions. Les résultats peuvent ne pas prendre en compte votre situation particulière et ne constituent pas une recommandation reliée à un placement ou à une stratégie. Ces renseignements ne visent pas à offrir des conseils financiers; d’autres facteurs devraient être pris en compte pour la détermination de vos objectifs et de votre stratégie financière. Le questionnaire Point de départ ne fournit pas tous les renseignements qui pourraient être pertinents dans votre situation particulière.`,
    resultsError:
      'Oh, non! Nous avons rencontré un problème technique lors de l’envoi de vos résultats. Veuillez recommencer.',
    downloadError: 'Un problème est survenu; veuillez réessayer.',
    timestampError:
      'Nous sommes désolés, mais il nous est impossible d’envoyer vos résultats automatiquement pour le moment. Veuillez télécharger vos résultats pour en discuter avec votre conseiller en investissement local ou demandez un nouveau lien.',
    topResultsHeading: 'Vos meilleurs résultats',
    moreResultsHeading: 'Plus de résultats pertinents pour vous.',
    startOverButton: 'Recommencer',
    downloadPdfButton: 'Télécharger vos résultats',
    findFaButton: 'Trouver un conseiller en investissement',
    findFaLink:
      'https://www.edwardjones.ca/ca-fr/recherche/conseiller-en-investissement/resultats?source=sp',
    myPrioritiesLinkBox: {
      header: `Quelles sont vos priorités?`,
      paragraph: `Besoin d’aide pour déterminer vos priorités financières? Le questionnaire Mes priorités peut vous aider. Il s’agit d’une étape importante dans l’élaboration d’une stratégie financière complète.`,
      buttonText: `Répondre au questionnaire Mes priorités`,
      link: `${window.location.origin}?callerAppName=StartingPoint`, // Logic to switch startingpoint to mypriorities within app
      imgSrc: `/public/images/my-priorities.png`,
      ariaLabel: `Ordinateur et téléphone mobile présentant le questionnaire Mes priorités`,
    },
    retireCalcLinkBox: {
      header: `Calculatrice d’épargne-retraite`,
      paragraph: `Un pourcentage de 70% des préretraités pensent qu'ils n'ont pas suffisamment épargné pour leur retraite. Et vous? Pensez-vous être sur la bonne voie? Utilisez notre calculatrice afin de valider le tout.`,
      buttonText: `Essayez la calculatrice d’épargne-retraite`,
      link: `https://www.edwardjones.ca/ca-fr/actualite-des-marches-et-perspectives/calculatrices-financieres/calculatrice-de-retraite`,
      imgSrc: `/public/images/calculator.png`,
      ariaLabel: `Calculatrice`,
    },
    eJMatchLinkBox: {
      header: `Find the best financial advisors for you`,
      paragraph: `Edward Jones match only takes 5 minutes and matches you on 40 match dimensions to find your best fit.`,
      buttonText: `Match with a financial advisor`,
      link: `https://match.edwardjones.com/`,
      imgSrc: `/public/images/client-and-advisor.png`,
      ariaLabel: `Client et conseiller en investissement discutant d'un document`,
    },
    shareQuizCta: {
      shareQuizHeading:
        'Partagez le lien vers le questionnaire Point de départ',
      shareQuizMessage:
        'Partagez le questionnaire Point de départ avec vos amis ou votre famille et comparez vos résultats.',
      copyLinkButton: 'Copier le lien',
      linkCopiedSuccessfully: 'Lien copié',
      copiedUrl: 'https://pointdedépart.edwardjones.ca/',
      shareLink: 'Partager le lien\xa0:',
      defaultEmailText: `mailto:?subject=Je crois que le questionnaire Point de départ pourrait vous intéresser&body=Utilisez ce questionnaire pour vous aider à vous lancer sur la voie de l'atteinte de vos objectifs financiers\xa0:${window.location.origin}`,
      linkedInUrl: `https://linkedin.com/sharing/share-offsite/?url=${window.location.origin}`,
      faceBookUrl: `https://www.facebook.com/share.php?u=${window.location.origin}`,
      socialMediaTitle: 'Partager sur %APP_NAME%',
    },
  },
  Error: {
    errorTextLine1: `Nous sommes désolés, mais un problème est survenu.`,
    errorTextLine2: `Nous travaillons à le résoudre. Veuillez réessayer plus tard.`,
    firstPageLinkText: `Retour au questionnaire`,
  },
  AllPages: {
    App: {
      personalPath: '/',
      householdPath: '/menage',
      goalsPath: '/espoirs',
      resultsPath: '/resultats',
      errorPath: '/erreur',
    },
    LanguageSelect: {
      languageSelectLabel: 'Pays: ',
      languageSelectTexts: 'Canada | English,Canada | Français',
      languageSelectTextDefault: 'Canada | Français',
      languageDialogCancel: 'Annuler/Cancel',
      languageDialogLeave: 'Sortir/Leave',
      languageDialogTitle1: 'Vous perdrez votre progression.',
      languageDialogTitle2: 'You will lose your quiz progress.',
      languageDialogQuestion1: 'Que souhaitez-vous sortir du questionnaire?',
      languageDialogQuestion2: 'Do you want to leave your quiz?',
    },
    StepIndicator: {
      steps: ['Particulier', 'Ménage', 'Objectifs', 'Résultats'],
      stepUrls: ['/', '/menage', '/espoirs', '/resultats'],
    },
    TopBar: {
      heading: 'Point de départ',
      link: 'https://www.edwardjones.ca',
    },
    BottomBar: {
      careersLink: `https://careers.edwardjones.com/fr-CA/`,
      careersText: `Carrières`,
      feedbackLink: `https://www.edwardjones.ca/ca-fr/nous-contacter`,
      feedbackText: `Commentaires`,
      privacyLink: `https://www.edwardjones.ca/ca-fr/divulgations/protection-du-compte-et-confidentialite/avis-de-confidentialite`,
      privacyText: `Confidentialité`,
      disclosuresLink: `https://www.edwardjones.ca/ca-fr/divulgations`,
      disclosuresText: `Divulgations`,
      accessibilityLink: `https://www.edwardjones.ca/ca-fr/politique-surlaccessibilite`,
      accessibilityText: `Politique sur l’accessibilité`,
      member: `Membre - `,
      CIPFLink: `https://www.fcpi.ca`,
      CIPFText: `le Fonds canadien de protection des investisseurs`,
      member2: `. Membre - `,
      IIROCLink: `https://www.ocri.ca/`,
      IIROCText: `Organisme canadien de réglementation des investissements`,
      line1: `Bienvenue au site Web Edward Jones. Ce site est publié au Canada uniquement à l'intention des résidents des compétences territoriales du Canada où la loi nous autorise à offrir nos produits et services. Les services offerts dans ce site peuvent être obtenus exclusivement par l'entremise des conseillers en investissement Edward Jones du Canada, lesquels ne peuvent entrer en relation d'affaires qu'avec les résidents de la ou des provinces où ils sont autorisés.`,
      line2: `Tous droits réservés © %CURRENT_YEAR% Edward D. Jones & Co., L.P. Des copies uniques de nos pages Internet peuvent être téléchargées ou imprimées pour usage personnel seulement. Autrement, il est interdit de modifier, copier, distribuer, transmettre, afficher, exécuter, reproduire, publier, céder ou consentir une licence, créer des œuvres dérivées à partir de, transférer ou vendre toute information, tout logiciel, tout produit ou service obtenu à partir de ce site.`,
      line3: `Edward Jones, société en commandite établie au Canada, est une filiale en propriété exclusive de Edward D. Jones & Co., LP, société en commandite du Missouri. Edward D. Jones & Co., L.P. est une filiale en propriété exclusive de The Jones Financial Companies, LLLP, une société en commandite à responsabilité limitée.`,
      line4: `Edward Jones MD est une marque déposée de Edward D. Jones & Co., L.P. Edward Jones et sa société affiliée indépendante aux États-Unis desservent ensemble près de 7 millions d'investisseurs.`,
      line5: `*Au Québec, nos conseillers sont désignés sous le nom de conseillers en investissement.`,
    },
    backButton: 'Précédent',
    nextButton: 'Suivant',
  },
};

/**
 * getText returns static text based on locale ID
 * @param {string} locId - the locale Id of the user taking the quiz
 * @param {string} page - page where the text lives
 * @param {string} component - OPTIONAL - the component nested within the page where the text lives
 * @param {string} line - the line within the component where the text should be placed
 * @returns {string} - Text to be populated in the specific component
 */
export default function getText(locId, page, line, component) {
  switch (locId) {
    case 'en_US':
      return component ? enUS[page][component][line] : enUS[page][line];
    case 'en_CA':
      return component ? enCA[page][component][line] : enCA[page][line];
    case 'fr_CA':
      return component ? frCA[page][component][line] : frCA[page][line];
    default:
      return component ? enUS[page][component][line] : enUS[page][line];
  }
}
